import { PAGES } from "#/constants";
import { BREADCRUMPS_CONFIG, PAGE_INFO_CONFIG } from "../components";
import { LayoutPropsConfig } from "./types";

export const LAYOUT_CONFIG: LayoutPropsConfig = {
  [PAGES.PLANS]: {
    breadcrumpConfig: BREADCRUMPS_CONFIG.PLANS,
    pageInfo: PAGE_INFO_CONFIG.PLANS,
  },
  [PAGES.MY_PLAN]: (typePlan) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.MY_PLAN(typePlan),
    pageInfo: PAGE_INFO_CONFIG.MY_PLAN(typePlan),
  }),
  [PAGES.CONTACT]: (typePlan, companyLabel) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.CONTACT(typePlan),
    pageInfo: PAGE_INFO_CONFIG.CONTACT(typePlan, companyLabel),
  }),
  [PAGES.DETAILS_PLAN]: (typePlan, companyLabel) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.DETAILS_PLAN(typePlan),
    pageInfo: PAGE_INFO_CONFIG.DETAILS_PLAN(typePlan, companyLabel),
  }),
  [PAGES.COMPLEMENTARY_DATA]: (typePlan) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.COMPLEMENTARY_DATA(typePlan),
    pageInfo: PAGE_INFO_CONFIG.COMPLEMENTARY_DATA,
  }),
  [PAGES.CONTRACT]: (typePlan) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.CONTRACT(typePlan),
    pageInfo: PAGE_INFO_CONFIG.CONTRACT,
  }),
  [PAGES.DEPENDENTS]: (typePlan, conditionalFlag) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.DEPENDENTS(typePlan),
    pageInfo: PAGE_INFO_CONFIG.DEPENDENTS(!!conditionalFlag),
  }),
  [PAGES.ADD_DEPENDENT]: {
    breadcrumpConfig: BREADCRUMPS_CONFIG.ADD_DEPENDENT,
    pageInfo: PAGE_INFO_CONFIG.ADD_DEPENDENT,
    hasActionButtons: true,
  },
  [PAGES.NEW_DEPENDENTS]: (typePlan) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.NEW_DEPENDENTS(typePlan),
    pageInfo: PAGE_INFO_CONFIG.NEW_DEPENDENTS,
  }),
  [PAGES.PAYMENT]: (typePlan) => ({
    breadcrumpConfig: BREADCRUMPS_CONFIG.PAYMENT(typePlan),
    pageInfo: PAGE_INFO_CONFIG.PAYMENT,
  }),
};
